import React, {useContext} from 'react';
import {
  Breakpoints,
  styled,
  css,
  BreakpointWrapper,
} from '@volkswagen-onehub/components-core';
import {VehicleContext} from '../../utils/vehicle-context';
import {
  ResultsView,
  ResultsViewContext,
} from '../../utils/results-view-context';
import {getEVIncentives} from '../../utils/get-ev-incentives';
import CardHead from './card-grids/CardHead';
import CardStock from './card-grids/CardStock';
import CardSubHead from './card-grids/CardSubHead';
import CardDealer from './card-grids/CardDealer';
import CardLike from './card-grids/CardLike';
import CardJelly from './card-grids/CardJelly';
import CardColours from './card-grids/CardColours';
import CardIncentives from './card-grids/CardIncentives';
import CardDescription from './card-grids/CardDescription';
import DividerBottom from './card-grids/DividerBottom';
import DividerTop from './card-grids/DividerTop';
import CardActions from './card-grids/CardActions';
import CardDealerActions from './card-grids/CardDealerActions';
import { VehicleCategory } from '../../types/enums/vehicles';
import { VehicleData } from '../../types';

type Props = {
  vehicle: VehicleData;
};

type ResultsProps = {
  hasIncentives?: boolean;
  view: ResultsView;
  model?: string;
};

type ListViewStylesProps = {
  hasIncentives?: boolean;
};

const ListViewStyles = css<ListViewStylesProps>`

  overflow: hidden;

  @media (min-width: ${Breakpoints.b960}px) {
    width: 100%;
    min-height: 362px;
    grid-template-columns: minmax(32.5%, 390px) minmax(40.83%, auto) minmax(
        26.67%,
        320px
      );
    grid-template-rows: 30px auto 9px minmax(180px, 1fr) 1px 68px;
    grid-column-gap: 0;
    grid-row-gap: 0;
    grid-template-areas:
      'jelly         stock          like          '
      'jelly         model          price         '
      'jelly         topdivider     topdivider    '
      'jelly         description    colours       '
      'incentives    bottomdivider  bottomdivider '
      'incentives    dealeractions  dealeractions ';
  }
`;

const StyledCard = styled.div<ResultsProps>`
  position: relative;
  border: 1px solid rgb(223, 228, 232);
  border-radius: 8px;
  :focus-within {
    border: 1px solid #0077cc;
  }
  display: grid;
  grid-template-columns: 16px 1fr auto 16px;
  grid-template-rows: min-content 40px auto 9px auto 9px 1fr 40px 70px;
  padding-right: 0;
  grid-template-areas:
    'jelly         jelly               jelly            jelly'
    '.              stock               stock           like'
    '.              model               price           .'
    '.              topdivider          topdivider      .'
    '.              colours             colours         .'
    '.              bottomdivider       bottomdivider   .'
    '.              dealer              dealer          .'
    'incentives     incentives          incentives      incentives'
    'actions        actions             actions         actions';

  ${(props) => (props.view === ResultsView.LIST ? ListViewStyles : undefined)}
`;

export default ({vehicle}: Props) => {
  const view = useContext(ResultsViewContext).value;
  const incentives = getEVIncentives(vehicle);

  return (
    <VehicleContext.Provider value={vehicle}>
      <StyledCard
        view={view}
        model={vehicle.model_name}
        hasIncentives={
          incentives.count > 0 ||
          vehicle.category == VehicleCategory.CERTIFIED
        }
      >
        {/* 1. Status */}
        <CardStock />

        {/* 2. Model Name
            3. Trim Detail
            4. Mileage */}
        <CardHead />

        {/* 5. Favourite */}
        <CardLike />

        {/* 6. Price (disclaimer)
            7. Offer */}
        <CardSubHead />

        { /* Details DT, Grid View */
          view != ResultsView.GRID &&
          <BreakpointWrapper min={Breakpoints.b960}>
            {/* 8. Details */}
            <CardDescription vehicle={vehicle} />
          </BreakpointWrapper>
        }

        {/*  8. Exterior
            9. Interior */}
        <CardColours />

        {view == ResultsView.LIST ? (
          <React.Fragment>
            <BreakpointWrapper min={Breakpoints.default} max={Breakpoints.b960}>

              <CardDealer />

              <CardIncentives vehicle={vehicle} />

              <CardActions />
            </BreakpointWrapper>

            <BreakpointWrapper min={Breakpoints.b960}>
              {/* 12. Callout */}
              <CardIncentives vehicle={vehicle} />

              <CardDealerActions vehicle={vehicle}/>
            </BreakpointWrapper>
          </React.Fragment>
          )
          :
          (
            <React.Fragment>
              {/* 10. Dealer
                  11. Distance */}
            <CardDealer />

            {/* 12. Callout */}
            <CardIncentives vehicle={vehicle} />

            {/* 13. CTAs */}
            <CardActions />
          </React.Fragment>
        )}

        <CardJelly />
        <DividerBottom />
        <DividerTop />
      </StyledCard>
    </VehicleContext.Provider>
  );
};
